<div>
        <div class="legend-area" *ngIf="!legendDisabled">
            <div class="legend1">
                <div class="legend_item primary-color-border" [ngClass]="{'legend_item_selected primary-color-bg': legendItem.selected}"
                    (click)="selectLegendItem(legendItem)" *ngFor="let legendItem of legendData">{{legendItem.displayName}}</div>
            </div>
        </div>
        <div>
    
        </div>
        <div class="wrapper">
            <div id="graph-area" #graphArea></div>
        </div>
    </div>
    